export const daysOfWeek = [
  "일요일",
  "월요일",
  "화요일",
  "수요일",
  "목요일",
  "금요일",
  "토요일",
];

export const dayTypeMapping = {
  일요일: "sun_type_id",
  월요일: "mon_type_id",
  화요일: "tue_type_id",
  수요일: "wed_type_id",
  목요일: "thu_type_id",
  금요일: "fri_type_id",
  토요일: "sat_type_id",
};

export const DAYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

export const days = [
  "일요일",
  "월요일",
  "화요일",
  "수요일",
  "목요일",
  "금요일",
  "토요일",
];

export const dayTypeMappingForSide = {
  0: "sun_type_id",
  1: "mon_type_id",
  2: "tue_type_id",
  3: "wed_type_id",
  4: "thu_type_id",
  5: "fri_type_id",
  6: "sat_type_id",
};
